/** Shown where an underwriting answer adds or excludes a coverage. */
export const UW_PERIL_NOTES = {
  animalLiabilityExclusion: "Animal Liability Exclusion Applied",
  divingBoardSlideLiability: "Diving Board/ Slide Liability Included",
  trampolineLiability: "Trampoline Liability Coverage Included",
};
